import { handleAuthenticationFailure } from './AuthSession';

// Only responses to our authenticated backend requests can expire the session.
export function installAuthRequestMonitor(target, axios, getServerBase) {
  const originalFetch = target.fetch;
  const requestSession = (url, headers) => {
    try {
      const base = new URL(getServerBase(), target.location.href);
      const requestUrl = new URL(url, target.location.href);
      const prefix = base.pathname.replace(/\/$/, '');
      if (requestUrl.origin !== base.origin
          || (prefix && requestUrl.pathname !== prefix
            && !requestUrl.pathname.startsWith(`${prefix}/`))) return null;
      const values = new Headers(headers);
      const token = values.get('access_token');
      const user = values.get('user_id');
      return token && user ? { token, user } : null;
    } catch (_) {
      return null;
    }
  };
  const check = (session, response, body) => {
    if (session && session.token === localStorage.getItem('etv.access_token')
        && session.user === localStorage.getItem('etv.user_id')) {
      handleAuthenticationFailure(response, body);
    }
  };

  const monitoredFetch = async (input, init) => {
    const session = requestSession(typeof input === 'string' ? input : input.url || String(input),
      init?.headers ?? input?.headers);
    const response = await originalFetch.call(target, input, init);
    if (session) {
      if (response.status === 401) {
        check(session, response);
      } else if (response.headers.get('content-type')?.includes('json')) {
        try {
          check(session, response, await response.clone().json());
        } catch (_) { /* Non-JSON/errors remain available to the request's caller. */ }
      }
    }
    return response;
  };
  target.fetch = monitoredFetch;

  const checkAxios = response => {
    if (!response) return;
    const config = response.config;
    check(requestSession(axios.getUri(config), config.headers), response, response.data);
  };
  const interceptor = axios.interceptors.response.use(response => {
    checkAxios(response);
    return response;
  }, error => {
    checkAxios(error.response);
    return Promise.reject(error);
  });
  return () => {
    if (target.fetch === monitoredFetch) target.fetch = originalFetch;
    axios.interceptors.response.eject(interceptor);
  };
}
